import { Rocket, X } from '@phosphor-icons/react'
import { useTourStore } from './useTourStore'

/**
 * Shown on the Dashboard for first-time users who haven't completed the tour.
 * Condition (evaluated by parent): !tour.completed && decisions.length === 0
 *
 * Fixed to the bottom-right corner, non-blocking.
 */
export default function TourLauncher() {
  const { start, skip } = useTourStore()

  return (
    <div
      className="fixed bottom-6 right-6 z-50 anim-pop max-w-xs w-full"
      role="complementary"
      aria-label="Guided tour offer"
      data-testid="tour-launcher"
    >
      <div className="card-brutal bg-bg p-5 shadow-brutal-lg">
        {/* Dismiss button */}
        <button
          onClick={skip}
          aria-label="Dismiss guided tour"
          data-testid="tour-launcher-dismiss"
          className="absolute top-3 right-3 w-7 h-7 rounded-full border-2 border-edge grid place-items-center hover:bg-muted transition-colors"
        >
          <X size={12} weight="bold" />
        </button>

        {/* Icon + headline */}
        <div className="flex items-start gap-3 mb-3 pr-6">
          <div className="w-10 h-10 rounded-xl bg-primary/15 border-2 border-edge grid place-items-center shrink-0">
            <Rocket size={20} weight="duotone" className="text-primary-ink" />
          </div>
          <div>
            <div className="font-heading font-black text-base leading-tight">
              New here? 👋
            </div>
            <p className="text-xs text-ink-muted mt-0.5">
              Build your first decision in ~2 minutes.
            </p>
          </div>
        </div>

        {/* Steps preview */}
        <ol className="text-xs text-ink-muted space-y-1 mb-4 ml-1">
          {[
            'Name your decision',
            'Add the options',
            'Add rough numbers',
            'Run — see the winner',
          ].map((s, i) => (
            <li key={i} className="flex items-center gap-2">
              <span className="w-4 h-4 rounded-full bg-primary/15 border border-edge grid place-items-center font-bold text-[10px] text-primary-ink shrink-0">
                {i + 1}
              </span>
              {s}
            </li>
          ))}
        </ol>

        {/* Actions */}
        <div className="flex items-center gap-2">
          <button
            onClick={start}
            data-testid="tour-launcher-start"
            className="btn-primary text-sm py-2 px-4 flex-1 inline-flex items-center justify-center gap-1.5"
          >
            <Rocket size={14} weight="fill" /> Start tour
          </button>
          <button
            onClick={skip}
            data-testid="tour-launcher-skip"
            className="text-xs text-ink-muted hover:text-primary-ink underline underline-offset-2"
          >
            Skip, I'll explore
          </button>
        </div>
      </div>
    </div>
  )
}
